import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ANA_NAV, LAB_NAV, OLD_NAV, PLATFORM_NAV } from '../shared/constants/nav.js';
import { requestAnalyticsRefresh } from '../shared/utils/session-cache.js';

function NavItem({ item }) {
  return (
    <NavLink
      to={item.path}
      end={item.end === true || item.path === '/'}
      className={({ isActive }) =>
        'analytics-sidenav-link' +
        (isActive ? ' is-active' : '') +
        (item.status === 'lab' ? ' is-lab' : '')
      }
    >
      <span>{item.label}</span>
    </NavLink>
  );
}

export default function Sidebar() {
  const { pathname } = useLocation();
  const oldOn = pathname.indexOf('/old') === 0;
  const labOn = pathname.indexOf('/lab') === 0;
  const anaOn = pathname.indexOf('/ana-') === 0 || pathname.indexOf('/instagram-automatizaciones') === 0;
  const [refreshing, setRefreshing] = useState(false);

  return (
    <aside className="analytics-sidenav" aria-label="Navegación Analytics">
      <div className="analytics-sidenav-brand">
        <p className="analytics-eyebrow">GI Capital</p>
        <NavLink to="/" className="analytics-sidenav-title" end>
          Analytics
        </NavLink>
      </div>

      <nav className="analytics-sidenav-nav" aria-label="Métricas oficiales">
        <p className="analytics-sidenav-group">Oficial</p>
        {PLATFORM_NAV.map((item) => <NavItem key={item.id} item={item} />)}
      </nav>

      <nav className="analytics-sidenav-nav" aria-label="Centro multicanal de Ana">
        <details key={anaOn ? 'ana-on' : 'ana-off'} className="analytics-sidenav-details" defaultOpen={anaOn || true}>
          <summary className="analytics-sidenav-group">Ana</summary>
          <p className="analytics-sidenav-group-hint">Actividad y control por canal</p>
          {ANA_NAV.map((item) => <NavItem key={item.id} item={item} />)}
        </details>
      </nav>

      <nav className="analytics-sidenav-nav analytics-sidenav-nav--old" aria-label="Vistas anteriores">
        <details key={oldOn ? 'old-on' : 'old-off'} className="analytics-sidenav-details" defaultOpen={oldOn}>
          <summary className="analytics-sidenav-group">Old</summary>
          <p className="analytics-sidenav-group-hint">Vistas anteriores · no es la home</p>
          {OLD_NAV.map((item) => <NavItem key={item.id} item={item} />)}
        </details>
      </nav>

      <nav className="analytics-sidenav-nav analytics-sidenav-nav--lab" aria-label="Lab experimental">
        <details key={labOn ? 'lab-on' : 'lab-off'} className="analytics-sidenav-details" defaultOpen={labOn}>
          <summary className="analytics-sidenav-group">Lab <span className="analytics-sidenav-soon">exp</span></summary>
          <p className="analytics-sidenav-group-hint">No altera números oficiales</p>
          {LAB_NAV.map((item) => <NavItem key={item.id} item={{ ...item, status: 'lab' }} />)}
        </details>
      </nav>

      <div className="analytics-sidenav-foot">
        <button
          type="button"
          className="analytics-sidenav-refresh"
          disabled={refreshing}
          onClick={() => {
            if (refreshing) return;
            setRefreshing(true);
            requestAnalyticsRefresh();
            window.setTimeout(() => setRefreshing(false), 1600);
          }}
        >
          {refreshing ? 'Actualizando…' : 'Actualizar'}
        </button>
      </div>
    </aside>
  );
}
